


export interface ShipmentStopsParams {
	day: string,
	customerId?: string,
	tileId?: string,
}



export enum ShipmentStopsTileFilter {
	total = 0,
	delivered = 1,
	onWay = 2,
	atDc = 3,
}



export type ShipmentStopsTilesParams = Omit<ShipmentStopsParams, 'tileId'>